import styled from "styled-components";

import Checkmark from "../../assets/Checkmark.svg";
export const CheckBoxStyled = styled.input`
  position: relative;
  &:hover {
    cursor: pointer;
  }

  &::before {
    content: "";
    position: relative;
    top: 0px;
    left: 0px;
    display: block;
    width: 14px;
    height: 14px;
    background: #fff;
  }

  &::after {
    content: "";
    position: relative;
    bottom: 14px;
    left: 0px;
    display: block;
    width: 20px;
    height: 20px;
    border: 1px solid ${({ theme }) => theme.colors.disableText};
    border-radius: 6px;
    background: #fff;
  }
  &:checked::after {
    border-color: #725ed4;
    background: url(${Checkmark});
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const LabelStyled = styled.label`
  color: ${({ theme }) => theme.colors.dark.black};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
`;
